import { DateTime } from "luxon";
import dataService from "../../../helpers/dataService";

export const getSddStatus = (rightsAndDuties) => {
  if (!rightsAndDuties || rightsAndDuties.length === 0) {
    return "NSDD";
  }

  const activeEntry = rightsAndDuties.find((entry) => {
    if (!entry.endAt) {
      return true;
    }
    const endDate = DateTime.fromISO(entry.endAt);
    const now = DateTime.local();
    return endDate > now;
  });

  return activeEntry ? "SDD" : "NSDD";
};

export const getRsaType = (rights, RSA_TYPES) => {
  if (!rights || rights.length === 0) {
    return "Non renseigné";
  }

  const activeRight = rights.find(
    (right) => !right.endAt || right.endAt === null,
  );

  if (!activeRight) {
    return "Non renseigné";
  }

  const rsaType = RSA_TYPES.find((type) => type.id === activeRight.type);
  return rsaType ? rsaType.name : "Non renseigné";
};

export const getAge = (birthdate) => {
  if (!birthdate) return null;
  const birth = DateTime.fromISO(birthdate);
  const now = DateTime.local();
  const diff = now.diff(birth, "years").toObject();
  return Math.floor(diff.years);
};

export const getMaritalStatusLabel = (maritalStatus, MARITAL_STATUSES) => {
  if (!MARITAL_STATUSES || MARITAL_STATUSES.length === 0) {
    return "Non renseigné";
  }
  const status = MARITAL_STATUSES.find((s) => s.id === maritalStatus);
  return status ? status.name : "Non renseigné";
};

export const fetchSanctionProposals = async (payload) => {
  const {
    userRecipient,
    sanctionType,
    mainReason,
    otherReasons,
    pregnancy,
    allProposals,
  } = payload;

  return new Promise((resolve, reject) => {
    dataService.post(
      "eps/calculer-bareme-inscription",
      {
        userRecipient,
        sanctionType,
        mainReason,
        otherReasons: otherReasons || [],
        pregnancy: pregnancy || false,
        allProposals: allProposals || false,
      },
      (response) => {
        // MOCK: Injection de données de récurrence de manquement
        // À retirer quand l'API renverra ces données
        const enrichedResponse = {
          ...response,
          // recurrenceManquement: {
          //   type: "PERSISTANCE", // PREMIER, PERSISTANCE, ou REITERATION
          //   dateEP: "2025-11-15T10:00:00.000Z", // Date ISO de l'EP concernée
          //   idEP: "ep-12345", // ID de l'EP
          // },
        };
        resolve(enrichedResponse);
      },
      (error) => {
        reject(error);
      },
    );
  });
};

export const detectReiterationPersistance = (selectedMotif, epHistory) => {
  if (!epHistory || epHistory.length === 0) {
    return {
      type: "PREMIER",
      message: null,
      relatedEp: null,
    };
  }

  const now = DateTime.local();

  for (const ep of epHistory) {
    if (ep.mainReasonId === selectedMotif) {
      const notifDate = DateTime.fromISO(ep.notificationDate);
      const monthsDiff = now.diff(notifDate, "months").toObject().months;

      if (monthsDiff < 24) {
        return {
          type: "REITERATION",
          message: `Le motif sélectionné correspond au même manquement que lors de l'EP du ${DateTime.fromISO(
            ep.epDate,
          ).toFormat("dd/MM/yyyy")} (notifiée le ${DateTime.fromISO(
            ep.notificationDate,
          ).toFormat("dd/MM/yyyy")}).`,
          relatedEp: ep,
        };
      }
    }
  }

  return {
    type: "PERSISTANCE",
    message: `L'allocataire a déjà ${epHistory.length} EP antérieure(s) avec des manquements différents.`,
    relatedEp: null,
  };
};
